import RoundCard from "./RoundCard";
import { createRoundLoadingData } from "./utils/createRoundLoadingData";
import { RoundsEmptyState } from "./RoundsEmptyState";
import { jsx as _jsx } from "react/jsx-runtime";
export function RoundsGrid(_ref) {
  var _ref2;
  let {
    isLoading,
    data,
    loadingCount,
    maxCount,
    getItemClassName,
    roundType
  } = _ref;
  if (!isLoading && !(data !== null && data !== void 0 && data.length)) {
    return /*#__PURE__*/_jsx(RoundsEmptyState, {});
  }
  return /*#__PURE__*/_jsx("div", {
    className: "md:grid space-y-4 md:space-y-0 md:grid-cols-3 gap-6",
    children: (_ref2 = data && data.length > 0 ? data : createRoundLoadingData(loadingCount)) === null || _ref2 === void 0 ? void 0 : _ref2.slice(0, maxCount).map((round, i) => /*#__PURE__*/_jsx("div", {
      className: getItemClassName === null || getItemClassName === void 0 ? void 0 : getItemClassName(round, i),
      children: /*#__PURE__*/_jsx(RoundCard, {
        round: round,
        isLoading: isLoading,
        index: i,
        roundType: roundType
      })
    }, round === null || round === void 0 ? void 0 : round.id))
  });
}